export const isQuickInvestLocalStorageKey = 'isQuickInvestEnabled';
